import { Stack, Typography } from '@mui/material'
import {
    AnnouncementsField,
    CurrencyField,
    LightsSelector,
    type AnnouncementsFieldProps,
    type LightsSelectorProps,
} from '@edge/spark/feature-mui-rhf-inputs'

export const EditSaleConditionsFormFields = ({
    disabled,
    lightOptions,
    loading,
    auctionType,
}: {
    disabled?: boolean
    lightOptions?: LightsSelectorProps['options']
    loading?: boolean
    auctionType: AnnouncementsFieldProps['auctionType']
}) => {
    return (
        <Stack gap={2}>
            <Typography fontWeight={600}>Sale Information</Typography>
            <CurrencyField
                fullWidth
                name="amt"
                label="Floor Price"
                decimalScale={0}
                disabled={disabled || loading}
                autoFocus
            />
            <Typography fontWeight={600}>Sale Conditions</Typography>
            <AnnouncementsField
                name="ments"
                label="Announcements"
                auctionType={auctionType}
                disabled={disabled}
                loading={loading}
            />
            <LightsSelector name="ight" label="Light(s)" options={lightOptions} disabled={disabled} loading={loading} />
        </Stack>
    )
}
